import axios from "./httpService";

export default {
  // params {service_patient_id, conclusion }
  endProduct: params => axios.post("/v3/product/end", params)
};
